import { render, staticRenderFns } from "./AdminOverview.vue?vue&type=template&id=cbb42ee0&scoped=true&"
import script from "./AdminOverview.vue?vue&type=script&lang=js&"
export * from "./AdminOverview.vue?vue&type=script&lang=js&"
import style0 from "./AdminOverview.vue?vue&type=style&index=0&id=cbb42ee0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb42ee0",
  null
  
)

export default component.exports